import React, {useState, useEffect, useContext} from "react";
import {
  UnorderedList,
  ListItem,
  Container, Button, VStack,
  Text,
} from '@chakra-ui/react';
import {useNavigate} from "react-router-dom";
import {client} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";

import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"

export const Home = () => {
  const [text, setText] = useState("");
  const [currentUser, setCurrentUser] = useState("")

  const {globalState, setGlobalState} = useContext(GlobalContext);
  useEffect(() => {
    (async () => {
      const resp = await client.home({bearerToken: bearerToken()});
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})

      setCurrentUser(resp.currentUser?.optName ?? "")
      setText(resp.text);
    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const navigate = useNavigate();

  return <Page>
    <PageHeader title={"Home"}></PageHeader>
    <PageBody>
      <Container>
        <VStack spacing={6}>
          <Text> {/* <ListIcon as={MdCheckCircle} /> */} { (currentUser !== "")? <>User: {currentUser}, </>: "" } {text}</Text>
          {
            (currentUser === "")?
              <Button onClick={() => {navigate("/login")}}>ログイン</Button>:
              <Button onClick={() => {navigate("/logout")}}>ログアウト</Button>
          }
        </VStack>
      </Container>
    </PageBody>
  </Page>
}
